export const ctFields = [
  {
    dataField: "Population",
    dataType: 'number',
    caption: 'Population',
    format: {
      type: 'fixed',
      decimals: 0,
      useSeparator: true
    }
  },
  {
    dataField: "OwnerOccupiedPctSFDetached",
    dataType: 'number',
    caption: 'Owner %',
    format: {
      type: 'fixed',
      decimals: 2,
      useSeparator: true,
      unitPrefix: "%"
    }
  },
  {
    dataField: "RenterOccupiedPctSFDetached",
    dataType: 'number',
    caption: 'Rent %',
    format: {
      type: 'fixed',
      decimals: 2,
      useSeparator: true,
      unitPrefix: "%"
    }
  },
  {
    dataField: "VacantPctSFDetached",
    dataType: 'number',
    caption: 'Vacant %',
    format: {
      type: 'fixed',
      decimals: 2,
      useSeparator: true,
      unitPrefix: "%"
    }
  },
  {
    dataField: "MedianRent",
    dataType: 'number',
    caption: 'Rent Price',
    format: {
      type: 'money',
      decimals: 0,
      useSeparator: true
    }
  },
  {
    dataField: "MedianAvmValue",
    dataType: 'number',
    caption: 'Median Home Value',
    format: {
      type: 'money',
      decimals: 0,
      useSeparator: true
    }
  },
  {
    dataField: "HPA6Mo",
    dataType: 'number',
    caption: 'HPA 6 Mo',
    format: {
      type: 'percent',
      decimals: 1,
      useSeparator: true
    }
  },
  {
    dataField: "AmherstEstimatedAMI",
    dataType: 'number',
    caption: 'AMI',
    format: {
      type: 'money',
      decimals: 0,
      useSeparator: true
    }
  },
  {
    dataField: "AffordabilityPmt",
    dataType: 'number',
    caption: 'Affordable Pmt',
    format: {
      type: 'money',
      decimals: 0,
      useSeparator: true
    },
  },
  {
    dataField: "AffordabilityPrice",
    dataType: 'number',
    caption: 'Affordability Price',
    format: {
      type: 'money',
      decimals: 0,
      useSeparator: true
    },
  },
  {
    dataField: "AffordabilityScore",
    dataType: 'number',
    caption: 'Affordability Score',
    format: {
      type: 'fixed',
      decimals: 2,
      useSeparator: true,
      unitPrefix: "%"
    }
  }
];
